import { render, staticRenderFns } from "./tkIntList.vue?vue&type=template&id=a8ba0fcc&scoped=true&"
import script from "./tkIntList.vue?vue&type=script&lang=js&"
export * from "./tkIntList.vue?vue&type=script&lang=js&"
import style0 from "./tkIntList.vue?vue&type=style&index=0&id=a8ba0fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ba0fcc",
  null
  
)

export default component.exports